import { useState } from "react";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";
import { Logo } from "@/components/Logo";

export const AdminLogin = ({ onLogin }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("dd_admin_token", data.token);
      onLogin(data);
    } catch (err) { setError(errMsg(err)); } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen grid place-items-center px-5 relative grain">
      <img src="/img/bg-front.webp" alt="" className="fixed inset-0 w-full h-full object-cover opacity-15 -z-10" />
      <form onSubmit={submit} data-testid="admin-login-form" className="panel p-8 w-full max-w-sm rise">
        <div className="flex justify-center mb-6"><Logo className="h-20" /></div>
        <h1 className="font-display text-2xl font-bold text-center mb-6">Panel administratora</h1>
        <div className="space-y-4">
          <Input data-testid="admin-login-email" type="email" required placeholder="E-mail" value={email} onChange={(e) => setEmail(e.target.value)} className="bg-black/50 h-11" />
          <Input data-testid="admin-login-password" type="password" required placeholder="Hasło" value={password} onChange={(e) => setPassword(e.target.value)} className="bg-black/50 h-11" />
          {error && <p data-testid="admin-login-error" className="text-sm text-red-400">{error}</p>}
          <button data-testid="admin-login-submit" disabled={busy} className="btn-y w-full py-3 text-sm">{busy ? "Logowanie..." : "Zaloguj"}</button>
        </div>
      </form>
    </div>
  );
};
